(() => {
  if (window.sublixExactPurchase) return;
  window.sublixExactPurchase = true;
  const quantityOwner = form => form.closest('sublix-card-purchase') || form.closest('.product-info') || form;
  const quantities = {
    get: form => quantityOwner(form).dataset.sbxUserQuantity,
    set: (form, value) => { quantityOwner(form).dataset.sbxUserQuantity = value; }
  };
  const managed = form => form && (form.querySelector('.sbx-exact-quantity') || form.closest('sublix-card-purchase'));
  const qty = form => form.querySelector('[data-sbx-card-quantity],.sbx-exact-quantity input[name="sbx_quantity"]');
  const syncOffer = (form, quantity) => {
    const root = form.closest('.product-info')?.querySelector('[class*="rapi-bundle-content-"]');
    if (!root) return;
    const offer = [...root.querySelectorAll('.rapi-bundles__bar')].map(bar => ({bar, minimum:Number((bar.querySelector('.rapi-bundles__bar-title')?.textContent || '').replace(/[^0-9]/g,'')) || 1})).filter(item => item.minimum <= Number(quantity)).sort((a,b) => b.minimum-a.minimum)[0];
    if (offer && !offer.bar.querySelector('input[type="radio"]')?.checked) offer.bar.querySelector('.rapi-content-outer-wrapper')?.click();
  };
  window.addEventListener('input', event => {
    const field = event.target;
    if (!event.isTrusted || !field.matches('.sbx-exact-quantity input[name="sbx_quantity"],[data-sbx-card-quantity]')) return;
    quantities.set(field.form, field.value);
    syncOffer(field.form, field.value);
  }, true);
  document.addEventListener('on:variant:change', event => {
    const form = event.detail?.form;
    if (!managed(form)) return;
    const field = qty(form);
    const quantity = quantities.get(form);
    if (field && quantity) { field.value = quantity; syncOffer(form, quantity); }
  });
  window.addEventListener('click', event => {
    const offer = event.target.closest('.rapi-bundles__bar');
    if (offer && event.isTrusted) {
      const form = offer.closest('.product-info')?.querySelector('form.js-product-form-main');
      const field = form && qty(form);
      if (field) {
        field.value = String(Number((offer.querySelector('.rapi-bundles__bar-title')?.textContent || '').replace(/[^0-9]/g,'')) || 1);
        quantities.set(form, field.value);
      }
    }
    const button = event.target.closest('button');
    const form = button && button.closest('form');
    if (!managed(form)) return;
    const field = qty(form);
    if (button.name === 'minus' || button.name === 'plus') {
      event.preventDefault();
      event.stopImmediatePropagation();
      const step = Number(field.step) || 1;
      const value = Math.max(Number(field.min) || 1, (Number(quantities.get(form) || field.value) || 1) + (button.name === 'plus' ? step : -step));
      field.value = String(field.max ? Math.min(value, Number(field.max)) : value);
      quantities.set(form, field.value);
      syncOffer(form, field.value);
      field.dispatchEvent(new Event('input', { bubbles:true }));
      return;
    }
    if (button.name !== 'add' || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    field.value = quantities.get(form) || field.value;
    if (!field.reportValidity()) return;
    form.dataset.sbxExactQuantity = field.value;
    form.closest('product-form').handleSubmit({target:form,preventDefault(){}});
  }, true);
  window.addEventListener('submit', event => {
    const form = event.target;
    if (!managed(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const field = qty(form);
    field.value = quantities.get(form) || field.value;
    if (!field.reportValidity()) return;
    form.dataset.sbxExactQuantity = field.value;
    form.closest('product-form').handleSubmit({target:form,preventDefault(){}});
  }, true);
})();
if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.cartDrawer = document.querySelector('cart-drawer');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      this.submitBtn = this.querySelector('[name="add"]');

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const requestedQuantity = Number(this.form.dataset.sbxExactQuantity || this.form.querySelector('[name="quantity"]')?.value || 1);
      const requestedVariant = this.form.querySelector('[name="id"]')?.value;
      const offerRoot = this.closest('.product-info')?.querySelector('[class*="rapi-bundle-content-"]');
      if (offerRoot && this.form.dataset.sbxExactQuantity) {
        const offers = [...offerRoot.querySelectorAll('.rapi-bundles__bar')].map(bar => {
          const title = bar.querySelector('.rapi-bundles__bar-title')?.textContent || '';
          return {bar, minimum:Number(title.replace(/[^0-9]/g,'')) || 1};
        }).filter(offer => offer.minimum <= requestedQuantity).sort((a,b) => b.minimum-a.minimum);
        const radio = offers[0]?.bar.querySelector('input[type="radio"]');
        if (radio && !radio.checked) {
          offers[0].bar.querySelector('.rapi-content-outer-wrapper')?.click();
          await new Promise(resolve => setTimeout(resolve, 180));
        }
      }
      const formData = new FormData(this.form);
      formData.delete('sbx_quantity');
      if (this.form.dataset.sbxExactQuantity) {
        formData.set('quantity', String(requestedQuantity));
        formData.set('id', requestedVariant);
        const quantityField = this.form.querySelector('[name="quantity"]');
        if (quantityField) quantityField.value = String(requestedQuantity);
      }
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      let addedSuccessfully = false;
      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const productId = this.form.closest('sublix-card-purchase')?.dataset.productId || this.form.querySelector('[name="product-id"]')?.value;
        if (productId && window.SublixVolume && this.form.dataset.sbxExactQuantity) {
          const matchingLines = oldCartData.items.filter(item => String(item.product_id) === String(productId));
          const combinedQuantity = requestedQuantity + matchingLines.reduce((sum,item) => sum + item.quantity, 0);
          const tier = window.SublixVolume.offer(productId, window.SublixVolume.collections(this.form), combinedQuantity);
          if (tier) {
            const properties = window.SublixVolume.properties(productId, tier);
            for (const [key,value] of Object.entries(properties)) formData.set('properties[' + key + ']', value);
            for (const item of matchingLines) {
              if (item.properties?.__rapi_offer === properties.__rapi_offer) continue;
              const changed = await (window.sublixCartFetch || window.fetch.bind(window))(theme.routes.cart + '/change.js', {
                method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
                body:JSON.stringify({id:item.key,quantity:item.quantity,properties:{...item.properties,...properties}})
              });
              if (!changed.ok) throw new Error('No se pudo actualizar el descuento de tu carrito.');
            }
          }
        }

        const response = await (window.sublixCartFetch || window.fetch.bind(window))(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);
        addedSuccessfully = true;

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        if (this.errorMsg?.hidden !== false) this.setErrorMsgState('No se pudo añadir el producto. Revisa tu carrito y vuelve a intentarlo.');
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        // Re-enable 'Add to Cart' button.
        if (addedSuccessfully) this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}

